// extracted by mini-css-extract-plugin
export default {"container":"Do-z","bubbleNav":"Eo-z","graphic":"Fo-z","contact":"Go-z"};